import { CheckboxField, Col, TextInputField } from '@/components';
import { PS_MAX_KEYWORD_SEARCH_LENGTH } from '@/features/project/_utils/constants';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { useProjectsSearchStore } from '@/features/search/_stores/projects-search-store';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { isPS } from '@/utils';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  useGenerateKeywordHintText,
  useKeywordFieldInitializeEffect,
} from './hooks/keyword-field-control';

export const KeywordColField: FC = () => {
  const { t } = useTranslation();
  const { type } = useProjectsSearchStore();

  const {
    control: sharedSearchControl,
    formState: { errors },
  } = useFormContext<SharedSearchFormType>();
  const sheetType = useWatch({
    control: sharedSearchControl,
    name: 'sheetType',
  });

  const { control: projectSearchControl, setValue: setProjectSearchValue } =
    useFormContext<ProjectSearchFormType>();
  const [fundSheetType, skipAdministrativeReformTeamEvaluation] = useWatch({
    control: projectSearchControl,
    name: ['fundSheetType', 'skipAdministrativeReformTeamEvaluation'],
  });

  const isRSAndAdministrativeReformTeamEvaluation =
    sheetType === 'RS' && skipAdministrativeReformTeamEvaluation === 'true';

  useKeywordFieldInitializeEffect({
    skipAdministrativeReformTeamEvaluation:
      skipAdministrativeReformTeamEvaluation === 'true'
        ? skipAdministrativeReformTeamEvaluation
        : undefined,
    type,
    setProjectSearchValue,
  });

  const hintText = useGenerateKeywordHintText({
    isRSAndAdministrativeReformTeamEvaluation,
    sheetType,
    fundSheetType,
  });

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <TextInputField
        name="q"
        label={t('search-keyword')}
        placeholder={t('placeholder-keyword-and-or')}
        hint={hintText}
        additionalLabelComponent={
          <CheckboxField
            text={t('search-keyword-project-name')}
            name="isSearchTargetProjectName"
            control={sharedSearchControl}
            errors={errors}
            disabled={isRSAndAdministrativeReformTeamEvaluation}
            wrapperStyle={{
              marginBottom: 0,
              marginLeft: 4,
              height: '22px',
              // .ant-form-item-control-inputのmin-heightを上書きするのが難しいので無理やり位置調整してます。
              transform: 'translateY(-4px)',
            }}
          />
        }
        control={sharedSearchControl}
        errors={errors}
        {...(isPS() && { maxLength: PS_MAX_KEYWORD_SEARCH_LENGTH })}
        allowClear
      />
    </Col>
  );
};
